module.exports = __webpack_public_path__ + "img/connected.47b1f230.svg";